import React from "react";
import img1 from "./img/1.jpg";
import img2 from "./img/2.jpg";
import img4 from "./img/4.jpg";
import img6 from "./img/6.jpg";
import img7 from "./img/7.jpg";
import img9 from "./img/9.jpg";
import img11 from "./img/11.jpg";
import img12 from "./img/12.jpg";
import img13 from "./img/13.jpg";
import img14 from "./img/14.jpg";
import img15 from "./img/15.jpg";
import img16 from "./img/16.jpg";
import img18 from "./img/18.jpg";
import img19 from "./img/19.jpg";
import img20 from "./img/20.jpg";
import img21 from "./img/21.jpg";
import img22 from "./img/22.jpg";
import img23 from "./img/23.jpg";
import img26 from "./img/26.jpg";
import img27 from "./img/27.jpg";
import img28 from "./img/28.jpg";
import img29 from "./img/29.jpg";
import img30 from "./img/30.jpg";
import img31 from "./img/31.jpg";
import img32 from "./img/32.jpg";
import img33 from "./img/33.jpeg";
import img34 from "./img/34.jpg";
import img35 from "./img/35.jpg";

const GallerySection = () => {
  const images = [
    img29,
    img28,
    img14,
    img2,
    img27,
    img9,
    img11,
    img4,
    img35,
    img6,
    img33,
    img12,
    img31,
    img13,
    img30,
    img1,
    img15,
    img16,
    img7,
    img18,
    img19,
    img20,
    img21,
    img22,
    img23,
    img26,
    img32,
    img34,
  ];

  // Function to shuffle the images array
  const shuffleArray = (array) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };

  const shuffledImages = shuffleArray([...images]);

  return (
    <div className="columns-1 sm:columns-2 md:columns-2 lg:columns-3 max-w-5xl  gap-3 mt-8 ">
      {shuffledImages.map((src, index) => (
        <div key={index} className="relative group mb-3 break-inside-avoid">
          <div className=" w-full rounded-lg overflow-hidden">
            <img
              className="object-cover w-full h-full transition-transform duration-300 transform group-hover:scale-105"
              src={src}
              alt={`gallery-photo-${index + 1}`}
            />
          </div>
        </div>
      ))}
    </div>
  );
};

export default GallerySection;
